module.exports = "/_next/static/images/australia-monotone-1b67a9b1e48a0cca1a63e052f8e54fe2.svg";